import API from "./apiLocal";

const CommonLocal = async (API_URL, API_PARAMS = {}, REQUEST_TYPE = "GET") => {
  let response = "";

  switch (REQUEST_TYPE) {
    case "POST":
      response = await API.post(API_URL, API_PARAMS);
      return response.data;
    case "PATCH":
      response = await API.patch(API_URL, API_PARAMS);
      return response.data;
    case "PUT":
      response = await API.put(API_URL, API_PARAMS);
      return response.data;
    default:
      response = await API.get(API_URL, { params: API_PARAMS });
      return await response.data;
  }
};

export default CommonLocal;
